export default function formatPhone(phoneNumber){
    let formatted = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    return formatted;
}